export const userData = [
    {
        name: 'Jan',
        "Active User": 4000,
    },
    {
        name: 'Feb',
        "Active User": 2000,
    },
    {
        name: 'Mar',
        "Active User": 3000,
    },
    {
        name: 'Apr',
        "Active User": 1000,
    },
    {
        name: 'May',
        "Active User": 3000,
    },
    {
        name: 'Jun',
        "Active User": 2500,
    },
    {
        name: 'Jul',
        "Active User": 1500,
    },
    {
        name: 'Aug',
        "Active User": 4000,
    },
    {
        name: 'Sept',
        "Active User": 4000,
    },
    {
        name: 'Oct',
        "Active User": 3500,
    },
    {
        name: 'Nov',
        "Active User": 1000,
    },
    {
        name: 'Dec',
        "Active User": 2800,
    },
];

export const userRows = [
    {
        id: 1, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 2, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 3, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 4, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 5, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 6, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 7, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 8, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 9, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 10, userName: 'Jon Snow', avatar: "https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        email: "john@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
]

export const productData = [
    {
        name: "Jan",
        "Sales": 4000,
    },
    {
        name: "Feb",
        "Sales": 3000,
    },
    {
        name: "Mar",
        "Sales": 5000,
    },
];

export const productRows = [
    {
        id: 1,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 2,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 3,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 4,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 5,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 6,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 7,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 8,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 9,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
    {
        id: 10,
        name: "Apple Airpods",
        img:
            "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        stock: 123,
        status: "active",
        price: "$120.00",
    },
];